import { render, staticRenderFns } from "./ModuleColumnBlock.vue?vue&type=template&id=cb1388fa"
var script = {}
import style0 from "./ModuleColumnBlock.vue?vue&type=style&index=0&id=cb1388fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports